import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  min-height: 48px;
  padding: 12px 8px 12px 12px;
  align-items: center;
  gap: 12px;
  width: 100%;
  border-radius: 4px;
  border: 1px solid ${({ theme }) => theme.colors.black3};
  background: ${({ theme }) => theme.colors.white};
  transition: all 0.2s ease-in-out;

  &:hover {
    border-color: ${({ theme }) => theme.colors.green6};
  }

  &:focus-within {
    border-color: ${({ theme }) => theme.colors.green6};
    box-shadow: 0px 0px 1px 2px ${({ theme }) => theme.colors.green2};
  }
`;

export const ButtonWrapper = styled.div`
  width: 32px;
`;

export const ActionsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: flex-start;

  .ant-form-item {
    margin-bottom: 0;
  }
`;

export const ColumnWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
`;

export const FormulaWrapper = styled.div`
  display: flex;
  font-size: 12px;
  padding-left: 12px;
`;
